import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _withScopeId = n => (_pushScopeId("data-v-630cb8c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_scope_1_activity_recorder_detail = _resolveComponent("scope-1-activity-recorder-detail")!
  const _component_scope_2_activity_recorder_detail = _resolveComponent("scope-2-activity-recorder-detail")!
  const _component_travel_logistic_mobility_activity_recorder_detail = _resolveComponent("travel-logistic-mobility-activity-recorder-detail")!
  const _component_spending_activity_recorder_detail = _resolveComponent("spending-activity-recorder-detail")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Detail",
          text: "Detail"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.activityData.emissionDataBase.scope == _ctx.viewModel.Scopes.Scope1)
        ? (_openBlock(), _createBlock(_component_scope_1_activity_recorder_detail, {
            key: 0,
            activityData: _ctx.activityData
          }, null, 8, ["activityData"]))
        : _createCommentVNode("", true),
      (_ctx.activityData.emissionDataBase.scope == _ctx.viewModel.Scopes.Scope2)
        ? (_openBlock(), _createBlock(_component_scope_2_activity_recorder_detail, {
            key: 1,
            activityData: _ctx.activityData
          }, null, 8, ["activityData"]))
        : _createCommentVNode("", true),
      (_ctx.activityData.emissionDataBase.scope == _ctx.viewModel.ScopesActivityRecorder.TravelLogisticMobility)
        ? (_openBlock(), _createBlock(_component_travel_logistic_mobility_activity_recorder_detail, {
            key: 2,
            activityData: _ctx.activityData
          }, null, 8, ["activityData"]))
        : _createCommentVNode("", true),
      (_ctx.activityData.emissionDataBase.scope == _ctx.viewModel.ScopesActivityRecorder.Spending)
        ? (_openBlock(), _createBlock(_component_spending_activity_recorder_detail, {
            key: 3,
            activityData: _ctx.activityData
          }, null, 8, ["activityData"]))
        : _createCommentVNode("", true)
    ])
  ]))
}